/**
 * DocsPage constants — RBAC allowlist + filter dropdown options.
 * Lives in components/ (not pages/) so the page-template guard doesn't
 * mistake it for a page that needs PageCanvas.
 *
 * Email allowlist is a hardcoded pragma. TODO: migrate to pipeline_config
 * SSoT slug `frontend.docs_search_allowlist` per Hard Rule #23 once the
 * doc-store search rolls out beyond Commander+Simon.
 */

export const DOC_SEARCH_EMAIL_ALLOWLIST: ReadonlySet<string> = new Set([
  'david.fuchs@clanda.de',
  'david.fuchs@extern.clanda.de',
  'david@appic.io',
  'simon.werner@clanda.de',
  'simon@appic.io',
])

export function isAllowed(email: string | null | undefined): boolean {
  if (!email) return false
  return DOC_SEARCH_EMAIL_ALLOWLIST.has(email.toLowerCase().trim())
}

export const DOC_TYPES: Array<{ value: string; label: string }> = [
  { value: 'all', label: 'Alle Typen' },
  { value: 'adr', label: 'ADR' },
  { value: 'spec', label: 'Spec' },
  { value: 'mo_spec', label: 'MO Spec' },
  { value: 'sortie_contract', label: 'Sortie Contract' },
  { value: 'flight_plan', label: 'Flight Plan' },
  { value: 'debrief', label: 'Debrief' },
  { value: 'handover', label: 'Handover' },
  { value: 'governance', label: 'Governance' },
  { value: 'tech_doc', label: 'Tech Doc' },
  { value: 'tech_spec', label: 'Tech Spec' },
  { value: 'reference', label: 'Reference' },
  { value: 'runbook', label: 'Runbook' },
  { value: 'standard', label: 'Standard' },
  { value: 'directive', label: 'Directive' },
  { value: 'dogma', label: 'Dogma' },
  { value: 'assessment', label: 'Assessment' },
  { value: 'feature_request', label: 'Feature Request' },
  { value: 'ticket', label: 'Ticket' },
  { value: 'signal', label: 'Signal' },
  { value: 'other', label: 'Other' },
]

export const DOC_STATUSES: Array<{ value: string; label: string }> = [
  { value: 'all', label: 'Alle Status' },
  { value: 'active', label: 'Active' },
  { value: 'draft', label: 'Draft' },
  { value: 'closed', label: 'Closed' },
  { value: 'superseded', label: 'Superseded' },
  { value: 'archived', label: 'Archived' },
]
